import { withViewModel } from '@hooks/useViewModel';
import RHFCountySelect from './RHFCountySelect';
import useRHFCountySelect from './useRHFCountySelect';

const CountySelectContainer = withViewModel(RHFCountySelect, useRHFCountySelect);

export default CountySelectContainer;
